import { useQuery } from '../services/NetworkManager';
import { NetworkManager } from '../services';

export type SourceType = 'SILVER_SAVING' | 'GOLD_SAVING';

export type SubscriptionState = 'ACTIVE' | 'PAUSED' | 'CANCELLED' | 'COMPLETED';

export type SubscriptionFrequency = 'DAILY' | 'WEEKLY' | 'MONTHLY';

export type Subscription = {
  subscriptionId: string;
  subscriptionState: SubscriptionState;
  subscriptionFrequency: SubscriptionFrequency;
  amount: number;
  startDate: string;
  endDate: string | null;
  pausedOn: string | null;
};

export type UserSipStatusResponse = {
  userId: number;
  subscriptions: Subscription[];
};

export function getUserSipStatus(userPublicId: string, sourceType: SourceType) {
  const path = NetworkManager.PATH.getUserSipStatus
    .replace('{{userPublicId}}', userPublicId)
    .replace('{{sourceType}}', sourceType);
  
  return NetworkManager.Call({
    method: 'get',
    path: path,
  });
}

export default function useUserSubscription(userPublicId?: string, sourceType?: SourceType) {
  const { data, isLoading, isError, error, refetch } = useQuery(
    ['getUserSipStatus', userPublicId, sourceType],
    () => {
      if (!userPublicId || !sourceType) {
        return Promise.resolve(null);
      }
      return getUserSipStatus(userPublicId, sourceType);
    },
    {
      enabled: !!userPublicId && !!sourceType,
    }
  );

  return {
    data: data as UserSipStatusResponse | undefined,
    isLoading,
    isError,
    error,
    refetch,
  };
}
